<div class="content content-with-elevation display-error">
  Something went wrong. Please try your request again later. Click "Root Zone Management" to return Home.
</div>
